/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import Page from '../../../components/Page';
import subscriptionServices from '../../../services/subscriptionServices';
import SnackBar from '../../../components/snackbar/snackbar';
import EditDrawer from './components/detail/EditDrawer';

import {
  PlansCardGrid, PlanTable,
  B2BBanner, EmptyState,
  CardSkeletons, TableSkeletons,
} from './components/listing/ListingComponents';

const TABS = [
  { key: 'assessment', label: 'Assessment Plans', route: '/app/subscription/create/assessment' },
  { key: 'single', label: 'Single Course Plan', route: '/app/subscription/create/single' },
  { key: 'bundle', label: 'Course Bundle Plans', route: '/app/subscription/create/bundle' },
  { key: 'b2b', label: 'B2B Plans', route: '/app/subscription/create/b2b' },
  ...(process.env.REACT_APP_ENV === 'dev' ? [ { key: 'ebooks', label: 'E-Books Plans', route: '/app/subscription/create/ebooks' },] : []),
  // { key: 'ebooks', label: 'E-Books Plans', route: '/app/subscription/create/ebooks' },
];

const CREATE_LABELS = [
  'Create Assessment Plan',
  'Create Single Course Plan',
  'Create Bundle Plan',
  'Create B2B Plan',
  'Create E-Books Plan',
];
const PAGE_SIZE = 10;

const SINGLE_COLUMNS = [
  {
    key: 'name', label: 'Plan Name', width: '2fr',
    render: (p) => <span className="text-sm font-semibold text-gray-900">{p.name}</span>,
  },
  {
    key: 'displayName', label: 'Display Name', width: '2fr',
    render: (p) => <span className="text-sm text-gray-700">{p.displayName || '—'}</span>,
  },
  {
    key: 'courseName', label: 'Course Name', width: '2fr',
    render: (p) => (
      <span className="text-sm text-gray-700">
        {p.courseDetails?.[0]?.title || p.courses?.[0]?.title || '—'}
      </span>
    ),
  },
  {
    key: 'priceUSD', label: 'Price', width: '1fr',
    render: (p) => {
      const rawCost = p.payableCost ?? p.prices?.[0]?.actualCost;
      const cost = rawCost ? parseFloat(rawCost) : 0;
      if (!cost || cost === 0) {
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border bg-green-50 text-green-700 border-green-300">
            Free
          </span>
        );
      }
      return <span className="text-sm text-gray-700">₹{cost.toFixed(2)}</span>;
    },
  },
  {
    key: 'status', label: 'Status', width: '120px',
    render: (p) => {
      const isOnline = p.isOnline === true || p.isOnline === 'true';
      const isActive = p.isActive === true || p.isActive === 'true';
      const isDeleted = false;
      // !isActive && !isOnline;
      const isPublished = isActive && isOnline;
      if (isDeleted) return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border bg-red-50 text-red-500 border-red-300">Deleted</span>;
      const style = isPublished ? 'bg-green-100 text-green-800 border-green-300' : 'bg-amber-50 text-amber-700 border-amber-300';
      return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${style}`}>{isPublished ? 'Published' : 'Draft'}</span>;
    },
  },
];

const BUNDLE_COLUMNS = [
  {
    key: 'name', label: 'Plan Name', width: '2fr',
    render: (p) => <span className="text-sm font-semibold text-gray-900">{p.name}</span>,
  },
  {
    key: 'displayName', label: 'Display Name', width: '2fr',
    render: (p) => <span className="text-sm text-gray-700">{p.displayName || '—'}</span>,
  },
  {
    key: 'price', label: 'Price (₹/Year)', width: '1fr',
    render: (p) => {
      const cost = p.payableCost || p.prices?.[0]?.actualCost;
      return (
        <span className="text-sm text-gray-700">
          {cost ? `₹${Number(cost).toLocaleString('en-IN')}` : '—'}
        </span>
      );
    },
  },
  {
    key: 'courseCount', label: 'Courses', width: '80px',
    render: (p) => {
      const count = p.courseDetailsNew?.filter((c) => c.type === 'course').length
        ?? p.courses?.length
        ?? p.courseDetails?.filter((c) => c.type === 'course').length
        ?? 0;
      return <span className="text-sm text-gray-700">{count}</span>;
    },
  },
{
    key: 'status', label: 'Status', width: '120px',
    render: (p) => {
      const isOnline = p.isOnline === true || p.isOnline === 'true';
      const isActive = p.isActive === true || p.isActive === 'true';
      const isDeleted = false;
      // !isActive && !isOnline;
      const isPublished = isActive && isOnline;
      if (isDeleted) return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border bg-red-50 text-red-500 border-red-300">Deleted</span>;
      const style = isPublished ? 'bg-green-100 text-green-800 border-green-300' : 'bg-amber-50 text-amber-700 border-amber-300';
      return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${style}`}>{isPublished ? 'Published' : 'Draft'}</span>;
    },
},
];

const EBOOKS_COLUMNS = [
  {
    key: 'name', label: 'Plan Name', width: '2fr',
    render: (p) => <span className="text-sm font-semibold text-gray-900">{p.name}</span>,
  },
  {
    key: 'displayName', label: 'Display Name', width: '2fr',
    render: (p) => <span className="text-sm text-gray-700">{p.displayName || '—'}</span>,
  },
  {
    key: 'price', label: 'Price (₹/Year)', width: '1fr',
    render: (p) => {
      const cost = Number(p.payableCost || p.prices?.[0]?.actualCost || 0);
      if (cost === 0) return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border bg-green-50 text-green-700 border-green-300">
          Free
        </span>
      );
      return <span className="text-sm text-gray-700">₹{cost.toLocaleString('en-IN')}</span>;
    },
  },
  {
    key: 'ebookCount', label: 'E-Books', width: '80px',
    render: (p) => {
      const count = p.courseDetailsNew?.filter((c) => c.type === 'ebook').length
        ?? p.ebooks?.length
        ?? p.courseDetails?.filter((c) => c.type === 'ebook').length
        ?? p.courses?.length
        ?? 0;
      return <span className="text-sm text-gray-700">{count}</span>;
    },
  },
  {
    key: 'status', label: 'Status', width: '120px',
    render: (p) => {
      const isOnline = p.isOnline === true || p.isOnline === 'true';
      const isActive = p.isActive === true || p.isActive === 'true';
      const isDeleted = false;
      //  !isActive && !isOnline;
      const isPublished = isActive && isOnline;
      if (isDeleted) return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border bg-red-50 text-red-500 border-red-300">Deleted</span>;
      const style = isPublished ? 'bg-green-100 text-green-800 border-green-300' : 'bg-amber-50 text-amber-700 border-amber-300';
      return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${style}`}>{isPublished ? 'Published' : 'Draft'}</span>;
    },
  },
];

const derivePlanScope = (p, planType) => {
  const rawScope = p.scope || p.plan_scope || '';
  if (rawScope) return rawScope.toLowerCase();
  if (planType === 'b2b') return 'b2b';
  if (planType === 'bundle') return 'bundle';
  if (planType === 'single') return 'single';
  if (planType === 'ebooks') return 'ebooks';
  return 'platform';
};

const normalizePlan = (p) => {
  let planType = (p.planType || p.plan_type || '').toLowerCase();

  if (!planType) {
    if (p.source === 'B2B_TEMPLATE') {
      planType = 'b2b';
    } else {
      const typeCode = (p.subscriptionType?.code || '').toUpperCase();
      const hasAssessments = Array.isArray(p.assessmentDetils) && p.assessmentDetils.length > 0;
      const hasCourses = Array.isArray(p.courseDetails) && p.courseDetails.some(d => d.type === 'course');
      const scopeVal = (p.scope || '').toLowerCase();
      const subName = (p.subscriptionInfo?.name || p.subscription || '').toLowerCase();

      const categoryMap = {
        ASSESSMENT: 'assessment',
        ASSESSMENT_BUNDLE: 'assessment',
        SINGLE_COURSE_PLAN: 'single',
        COURSE_BUNDLE: 'bundle',
        B2B: 'b2b',
        // The create flow stores plan_category as 'EBOOK'; keep the older aliases too.
        // EBOOK: 'ebooks',
        // EBOOK_PLAN: 'ebooks',
        // EBOOK_BUNDLE: 'ebooks',
      };

      if (typeCode === 'B2B') {
        planType = 'b2b';
      } else if (p.planCategory && categoryMap[p.planCategory]) {
        planType = categoryMap[p.planCategory];
      } else if (scopeVal === 'ebooks') {
        planType = 'ebooks';
      } else if (scopeVal === 'platform' || scopeVal === 'category') {
        planType = 'assessment';
      } else if (scopeVal === 'single' || scopeVal === 'bundle') {
        planType = scopeVal;
      } else if (hasCourses && hasAssessments) {
        planType = 'bundle';
      } else if (hasCourses && !hasAssessments) {
        planType = 'single';
      } else if (hasAssessments && !hasCourses) {
        planType = 'assessment';
      } else if (subName.includes('bundle') && hasCourses) {
        planType = 'bundle';
      } else if ((subName.includes('single') || subName.includes('course')) && hasCourses) {
        planType = 'single';
      } else if (subName.includes('ebook')) {
        planType = 'ebooks';
      } else {
        planType = 'assessment';
      }
    }
  }

  const scope = derivePlanScope(p, planType);
  const allDetails = Array.isArray(p.courseDetails) ? p.courseDetails : [];
  const courses = allDetails.filter((d) => d.type === 'course');
  const assessments = Array.isArray(p.assessmentDetils) ? p.assessmentDetils :
    allDetails.filter((d) => d.type === 'assessment');

  return {
    ...p,
    planType,
    scope,
    courses,
    assessments,
    description: p.description || '',
    displayName: (() => {
      try {
        const raw = p.shortDescription || p.short_desc || '';
        if (!raw) return '';
        if (Array.isArray(raw)) return raw[0] || '';
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed[0] || '' : raw;
      } catch {
        return '';
      }
    })(),
    tier: p.tier || '',
    featureBullets: p.featureBullets || p.feature_bullets || [],
    assessmentTypes: p.assessmentTypes || p.assessment_types || [],
    maxAttempts: p.maxAttempts || p.max_attempts || 5,
    tagline: p.tagline || '',
    stripeProductId: p.stripeProductId || p.stripe_product_id || '',
    imageUrl: p.imageUrl || p.image_url || '',
      billingtype: p.billing_type || p.billingtype || p.billingType || '',
  };
};

// ── Reusable search input with debounce ──────────────────────────────────────
const SearchInput = ({ value, onChange, placeholder = 'Search...' }) => (
  <div className="relative">
    <svg
      className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
      width="15" height="15" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-lg bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-[220px]"
    />
  </div>
);

// ── useDebounce hook ─────────────────────────────────────────────────────────
function useDebounce(value, delay = 400) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

const CreateButton = ({ label, route, navigate, activeTab }) => (
  <button
    type="button"
    onClick={() => navigate(route, { state: { fromTab: activeTab } })}
    className="inline-flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg px-4 py-2 border-none cursor-pointer flex-shrink-0 transition-colors duration-150"
  >
    + {label}
  </button>
);

const TablePagination = ({ total, page, pageSize, onPageChange }) => {
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between px-5 py-3 border-t border-gray-200 bg-gray-50 bg-white border border-gray-200 rounded-b-xl -mt-px">
      <p className="text-xs text-gray-400">
        Showing {start}–{end} of {total}
      </p>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          className="px-3 py-[5px] rounded-[6px] text-xs font-medium border border-gray-200 bg-white text-gray-600 cursor-pointer hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          ‹ Prev
        </button>
        {(() => {
          const delta = 2;
          const range = Array.from({ length: totalPages }, (_, i) => i + 1).filter(
            (i) => i === 1 || i === totalPages || (i >= page - delta && i <= page + delta)
          );
          const withEllipsis = range.reduce((acc, cur, idx) => {
            if (idx > 0 && cur - range[idx - 1] > 1) acc.push('...');
            acc.push(cur);
            return acc;
          }, []);
          return withEllipsis.map((p, idx) =>
            p === '...' ? (
              <span key={`ellipsis-${idx}`} className="px-1 text-xs text-gray-400 select-none">…</span>
            ) : (
              <button
                key={p}
                onClick={() => onPageChange(p)}
                className="w-[28px] h-[28px] rounded-[6px] text-xs font-medium border cursor-pointer"
                style={{
                  background: page === p ? '#2563eb' : '#fff',
                  color: page === p ? '#fff' : '#374151',
                  borderColor: page === p ? '#2563eb' : '#e5e7eb',
                }}
              >
                {p}
              </button>
            )
          );
        })()}
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          className="px-3 py-[5px] rounded-[6px] text-xs font-medium border border-gray-200 bg-white text-gray-600 cursor-pointer hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Next ›
        </button>
      </div>
    </div>
  );
};

const Subscriptions = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(Number(searchParams.get('tab')) || 0);
  const [loading, setLoading] = useState(true);
  const [editPlan, setEditPlan] = useState(null);
  
  const location = useLocation();
  const [snackbar, setSnackbar] = useState({ open: false, title: '' });

  const [tabData, setTabData] = useState({
    assessment_platform: { plans: [], total: 0 },
    assessment_category: { plans: [], total: 0 },
    single: { plans: [], total: 0 },
    bundle: { plans: [], total: 0 },
    b2b: { plans: [], total: 0 },
    ebooks: { plans: [], total: 0 },
  });
console.log(tabData,'tabDatatabDatatabData');

  const [pageMap, setPageMap] = useState({
    assessment: 1,
    single: 1,
    bundle: 1,
    b2b: 1,
    ebooks: 1,
  });

  // ── Search state (raw — typed by user) ────────────────────────────────────
  const [searchMap, setSearchMap] = useState({
    assessment_category: '',
    single: '',
    bundle: '',
    b2b: '',
    ebooks: '',
  });

  // ── Debounced search values sent to API ───────────────────────────────────
  const debouncedCategorySearch = useDebounce(searchMap.assessment_category);
  const debouncedSingleSearch   = useDebounce(searchMap.single);
  const debouncedBundleSearch   = useDebounce(searchMap.bundle);
  const debouncedB2BSearch      = useDebounce(searchMap.b2b);
  const debouncedEbooksSearch   = useDebounce(searchMap.ebooks);

  const [showDeleted, setShowDeleted] = useState(false);
  const [assessmentSubPages, setAssessmentSubPages] = useState({ platform: 1, category: 1 });

  const tabKey = TABS[activeTab].key;
  const tabRoute = TABS[activeTab].route;
  const tabCreateLabel = CREATE_LABELS[activeTab];

  const currentPlans = tabData[tabKey]?.plans || [];
  const currentTotal = tabData[tabKey]?.total || 0;
  const currentPage  = pageMap[tabKey];

  const platformPlans = tabData.assessment_platform.plans;
  const categoryPlans = tabData.assessment_category.plans;
  const platformTotal = tabData.assessment_platform.total;
  const categoryTotal = tabData.assessment_category.total;
  const platformPage  = assessmentSubPages.platform;
  const categoryPage  = assessmentSubPages.category;

  useEffect(() => {
    if (location.state?.message) {
      setSnackbar({ open: true, title: location.state.message });
      window.history.replaceState({}, '');
    }
  }, []);

  // ── Generic fetch ─────────────────────────────────────────────────────────
  const getPlans = async (key, pageNum, scope = null, search = '') => {
    setLoading(true);
    try {
      const res = await subscriptionServices.getSubscriptionPlans({
        planCategory: key,
        ...(scope && { scope }),
        page: pageNum,
        pageSize: PAGE_SIZE,
        includeInactive: showDeleted,
        ...(search && { search }),
      });
      const payload = res.data;
      if (payload?.rows) {
        const normalized = (payload.rows || []).map(normalizePlan);
        if (scope === 'platform') {
          setTabData((prev) => ({
            ...prev,
            assessment_platform: { plans: normalized.filter((p) => p.scope !== 'category'), total: payload.total },
          }));
        } else if (scope === 'category') {
          setTabData((prev) => ({
            ...prev,
            assessment_category: { plans: normalized.filter((p) => p.scope === 'category'), total: payload.total },
          }));
        } else {
          setTabData((prev) => ({
            ...prev,
            [key]: { plans: normalized, total: payload.total },
          }));
        }
      }
    } catch (e) {
      console.error('[getPlans]', e);
    }
    setLoading(false);
  };

  // ── Platform plans (no search) ────────────────────────────────────────────
  useEffect(() => {
    if (tabKey === 'assessment') getPlans('assessment', assessmentSubPages.platform, 'platform');
  }, [activeTab, showDeleted, assessmentSubPages.platform]); // eslint-disable-line

  // ── Category plans (with debounced search) ────────────────────────────────
  useEffect(() => {
    if (tabKey === 'assessment') {
      getPlans('assessment', assessmentSubPages.category, 'category', debouncedCategorySearch);
    }
  }, [activeTab, showDeleted, assessmentSubPages.category, debouncedCategorySearch]); // eslint-disable-line

  // ── Single plans (with debounced search) ──────────────────────────────────
  useEffect(() => {
    if (tabKey === 'single') getPlans('single', pageMap.single, null, debouncedSingleSearch);
  }, [activeTab, showDeleted, pageMap.single, debouncedSingleSearch]); // eslint-disable-line

  // ── Bundle plans (with debounced search) ──────────────────────────────────
  useEffect(() => {
    if (tabKey === 'bundle') getPlans('bundle', pageMap.bundle, null, debouncedBundleSearch);
  }, [activeTab, showDeleted, pageMap.bundle, debouncedBundleSearch]); // eslint-disable-line

  // ── B2B plans (with debounced search) ─────────────────────────────────────
  useEffect(() => {
    if (tabKey === 'b2b') getPlans('b2b', pageMap.b2b, null, debouncedB2BSearch);
  }, [activeTab, showDeleted, pageMap.b2b, debouncedB2BSearch]); // eslint-disable-line

  // ── E-Books plans (with debounced search) ─────────────────────────────────────
  useEffect(() => {
    if (tabKey === 'ebooks') getPlans('ebooks', pageMap.ebooks, null, debouncedEbooksSearch);
  }, [activeTab, showDeleted, pageMap.ebooks, debouncedEbooksSearch]); // eslint-disable-line

  const handlePageChange = (newPage) => {
    setPageMap((prev) => ({ ...prev, [tabKey]: newPage }));
  };

  // Reset page to 1 when search changes
  const handleSearchChange = (key, value) => {
    setSearchMap((prev) => ({ ...prev, [key]: value }));
    if (key === 'assessment_category') {
      setAssessmentSubPages((prev) => ({ ...prev, category: 1 }));
    } else {
      setPageMap((prev) => ({ ...prev, [key]: 1 }));
    }
  };

  const handleToggleDeleted = () => {
    setShowDeleted((prev) => !prev);
    setPageMap({ assessment: 1, single: 1, bundle: 1, b2b: 1, ebooks: 1 });
    setAssessmentSubPages({ platform: 1, category: 1 });
  };

  const handleView = (plan) => {
    const resolvedType = plan.source === 'B2B_TEMPLATE' ? 'b2b' : plan.planType;
    navigate(`/app/subscription/${resolvedType}/${plan.id}`, { state: { source: plan.source } });
  };
  const handleEdit   = (plan) => setEditPlan(plan);

  const handleDelete = async (plan) => {
    try {
      const fd = new FormData();
      fd.append('name', plan.name);
      fd.append('isOnline', 'false');
      fd.append('categoryId', plan.categoryId != null ? String(plan.categoryId) : '');
      fd.append('isPaid', plan.isPaid === 'Paid' || plan.isPaid === true ? 'true' : 'false');
      fd.append('subscriptionType', plan.subscriptionType?.code || 'B2C');
      fd.append('prices', JSON.stringify(
        (plan.prices || []).map(p => ({
          currencyType: p?.currencyType?.code || p?.currencyType,
          actualCost: p?.actualCost ?? 0,
        }))
      ));
      fd.append('frequency', plan.billingCycle === 'YEARLY' || plan.billingCycle === 'Yearly' ? '1' : '2');
      fd.append('subscriptionPlan', plan.subscriptionInfo?.name || '');
     fd.append('billingtype', plan.billingtype || plan.billing_type || '');
      const res = await subscriptionServices.putSubscriptionPlan(plan.id, fd, plan.planType);
      if (res.ok) {
        setSnackbar({ open: true, title: 'Plan moved to draft' });
        getPlans(tabKey, currentPage);
      }
    } catch (e) { console.error('[handleDelete]', e); }
  };

  const handleDeletePlan = async (plan) => {
    try {
      let res;
      if (plan.source === 'B2B_TEMPLATE') {
        res = await subscriptionServices.deleteB2BTemplatePlan(plan.id);
      } else {
        res = await subscriptionServices.deleteSubscriptionPlans(plan.id);
      }
      if (res.status === 200) {
        setSnackbar({ open: true, title: 'Plan deleted successfully' });
        getPlans(tabKey, currentPage);
      }
    } catch (e) { console.error('[handleDeletePlan]', e); }
  };

  const handleTogglePublish = async (plan) => {
    try {
      let res;
      let isCurrentlyPublished;
      if (plan.source === 'B2B_TEMPLATE') {
        isCurrentlyPublished = plan.isOnline === true || plan.isOnline === 'true';
        const fd = new FormData();
        fd.append('name', plan.name);
        fd.append('isOnline', isCurrentlyPublished ? 'false' : 'true');
        if (plan.description) fd.append('description', plan.description);
        if (plan.courseDetails?.length) fd.append('courseIds', JSON.stringify(plan.courseDetails.filter(d => d.type === 'course').map(d => d.id)));
        if (plan.assessmentDetils?.length) fd.append('assessmentIds', JSON.stringify(plan.assessmentDetils.map(d => d.id)));
        res = await subscriptionServices.putB2BTemplatePlan(plan.id, fd);
      } else {
        isCurrentlyPublished = plan.isOnline === true || plan.isOnline === 'true';
        const fd = new FormData();
        fd.append('name', plan.name);
        fd.append('isOnline', isCurrentlyPublished ? 'false' : 'true');
        fd.append('isPaid', plan.isPaid === 'Paid' || plan.isPaid === true ? 'true' : 'false');
        fd.append('subscriptionType', plan.subscriptionType?.code || 'B2C');
        fd.append('prices', JSON.stringify(
          (plan.prices || [])
            .filter(p => ['INR', 'USD'].includes(p?.currencyType?.code || p?.currencyType))
            .map(p => ({ currencyType: p?.currencyType?.code || p?.currencyType, actualCost: p?.actualCost ?? 0 }))
        ));
        fd.append('frequency', plan.billingCycle === 'YEARLY' || plan.billingCycle === 'Yearly' ? '1' : '2');
        fd.append('subscriptionPlan', plan.subscriptionInfo?.name || 'Online Monthly');
        fd.append('tier', plan.tier || 'BASIC');
        fd.append('assessment_types', JSON.stringify(plan.assessmentTypes || plan.assessment_types || []));
        fd.append('feature_bullets', JSON.stringify(plan.featureBullets || plan.feature_bullets || []));
        fd.append('is_popular', plan.isPopular ? 'true' : 'false');
        fd.append('cta_label', plan.ctaLabel || '');
        fd.append('footnote', plan.footnote || '');
        fd.append('plan_category', plan.planCategory || '');
        fd.append('scope', plan.scope || 'platform');
        fd.append('tagline', plan.tagline || '');
        fd.append('max_attempts_per_assessment', plan.maxAttempts || 5);
        fd.append('courseIds', JSON.stringify((plan.courses || plan.courseDetails || []).map(c => Number(c.id))));
        fd.append('assessmentIds', JSON.stringify((plan.assessments || plan.assessmentDetils || []).map(a => Number(a.id))));
        fd.append('categoryId', plan.categoryId != null ? String(plan.categoryId) : '');
       fd.append('billingtype', plan.billingtype || plan.billing_type || '');
        res = await subscriptionServices.putSubscriptionPlan(plan.id, fd, plan.planType);
      }
      if (res.ok) {
        setSnackbar({ open: true, title: `Plan ${isCurrentlyPublished ? 'moved to draft' : 'published'}` });
        getPlans(tabKey, currentPage);
      }
    } catch (e) { console.error('[handleTogglePublish]', e); }
  };

  const handleSaveEdit = async (values) => {
    
    try {
      if (values._action === 'delete') {
        const fd = new FormData();
        fd.append('name', editPlan.name);
        fd.append('isOnline', 'false');
        let res;
        if (editPlan.source === 'B2B_TEMPLATE') {
          res = await subscriptionServices.putB2BTemplatePlan(editPlan.id, fd);
        } else {
          fd.append('isPaid', editPlan.isPaid === 'Paid' || editPlan.isPaid === true ? 'true' : 'false');
          fd.append('subscriptionType', editPlan.subscriptionType?.code || 'B2C');
          fd.append('prices', JSON.stringify(
            (editPlan.prices || []).map(p => ({ currencyType: p?.currencyType?.code || p?.currencyType, actualCost: p?.actualCost ?? 0 }))
          ));
          fd.append('frequency', editPlan.billingCycle === 'YEARLY' || editPlan.billingCycle === 'Annual V2' ? '1' : '2');
          fd.append('subscriptionPlan', editPlan.subscriptionInfo?.name || '');
          fd.append('billingtype', editPlan.billingtype || editPlan.billing_type || '');
          fd.append('is_active', editPlan.billingtype || editPlan.billing_type || '');
          res = await subscriptionServices.putSubscriptionPlan(editPlan.id, fd, editPlan.planType);
        }
        if (res.ok) {
          setSnackbar({ open: true,   title: 'Plan moved to draft' });
          setEditPlan(null);
          getPlans(tabKey, currentPage);
        }
        return;
      }

      const fd = new FormData();
      Object.entries(values).forEach(([k, v]) => {
        if (k === '_action' || v === null || v === undefined) return;
        if (v instanceof File) fd.append(k, v);
        else if (typeof v === 'string') fd.append(k, v);
        else if (Array.isArray(v) || typeof v === 'object') fd.append(k, JSON.stringify(v));
        else fd.append(k, v);
      });

      let res;
      if (editPlan.source === 'B2B_TEMPLATE') {
        res = await subscriptionServices.putB2BTemplatePlan(editPlan.id, fd);
      } else {
        res = await subscriptionServices.putSubscriptionPlan(editPlan.id, fd, editPlan.planType);
      }
      if (res.ok) {
        setSnackbar({ open: true, title: 'Plan updated' });
        setEditPlan(null);
        getPlans(tabKey, currentPage);
      }
    } catch (e) { console.error('[handleSaveEdit]', e); }
  };

  return (
    <Page title="">
      <div className="px-4 md:px-6 pt-4 pb-12 min-h-screen bg-gray-50">
        <h1 className="text-xl font-bold text-gray-900 leading-tight">Plans &amp; Pricing</h1>
        <p className="text-xs text-gray-500 mt-1 mb-6">
          Manage B2C and B2B subscription plans and content entitlements
        </p>

        {/* ── Tabs ── */}
        <div className="flex border-b border-gray-200 mb-7 overflow-x-auto">
          {TABS.map((tab, idx) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => {
                setActiveTab(idx);
                setPageMap((prev) => ({ ...prev, [TABS[idx].key]: 1 }));
                setAssessmentSubPages({ platform: 1, category: 1 });
              }}
              className={`px-5 py-2.5 text-sm whitespace-nowrap -mb-px cursor-pointer bg-transparent border-0 border-b-2 transition-colors duration-150
                ${activeTab === idx
                  ? 'font-semibold text-blue-600 border-blue-600'
                  : 'font-normal text-gray-500 border-transparent hover:text-gray-900'}`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* ── Assessment Plans ── */}
        {tabKey === 'assessment' && (
          <>
            {/* Platform Plans — no search */}
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm font-semibold text-gray-900">Platform Plans</span>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={handleToggleDeleted}
                  className="px-3 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 cursor-pointer"
                >
                  {showDeleted ? 'Hide deleted' : 'Show deleted'}
                </button>
                <CreateButton label={tabCreateLabel} route={tabRoute} navigate={navigate} />
              </div>
            </div>
            <div className="mb-10">
              {loading
                ? <CardSkeletons />
                : platformPlans.length > 0
                  ? (
                    <PlansCardGrid
                      plans={platformPlans}
                      onView={handleView}
                      onEdit={null}
                      onDelete={handleDelete}
                      onDeletePlan={handleDeletePlan}
                      onTogglePublish={null}
                    />
                  )
                  : <EmptyState label="platform plans" />}
            </div>
            <TablePagination
              total={platformTotal}
              page={platformPage}
              pageSize={PAGE_SIZE}
              onPageChange={(p) => setAssessmentSubPages((prev) => ({ ...prev, platform: p }))}
            />

            {/* Category Plans — WITH search */}
            <div className="flex items-center justify-between mb-4 mt-8">
              <span className="text-sm font-semibold text-gray-900">Category Plans</span>
              <SearchInput
                value={searchMap.assessment_category}
                onChange={(v) => handleSearchChange('assessment_category', v)}
                placeholder="Search category plans..."
              />
            </div>
            <div className="mb-10">
              {loading
                ? <CardSkeletons />
                : categoryPlans.length > 0
                  ? (
                    <PlansCardGrid
                      plans={categoryPlans}
                      onView={handleView}
                      onEdit={null}
                      onDelete={handleDelete}
                      onDeletePlan={handleDeletePlan}
                      onTogglePublish={null}
                    />
                  )
                  : <EmptyState label="category plans" />}
            </div>
            <TablePagination
              total={categoryTotal}
              page={categoryPage}
              pageSize={PAGE_SIZE}
              onPageChange={(p) => setAssessmentSubPages((prev) => ({ ...prev, category: p }))}
            />
          </>
        )}

        {/* ── Single Course Plan ── */}
        {tabKey === 'single' && (
          <>
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm font-semibold text-gray-900">Plan Records</span>
              <div className="flex items-center gap-2">
                <SearchInput
                  value={searchMap.single}
                  onChange={(v) => handleSearchChange('single', v)}
                  placeholder="Search plans..."
                />
                <button
                  type="button"
                  onClick={handleToggleDeleted}
                  className="px-3 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 cursor-pointer"
                >
                  {showDeleted ? 'Hide deleted' : 'Show deleted'}
                </button>
                <CreateButton label={tabCreateLabel} route={tabRoute} navigate={navigate} activeTab={activeTab} />
              </div>
            </div>
            {loading
              ? <TableSkeletons />
              : (
                <PlanTable
                  plans={currentPlans}
                  columns={SINGLE_COLUMNS}
                  onView={handleView}
                  onEdit={handleEdit}
                />
                
              )}
            <TablePagination
              total={currentTotal}
              page={currentPage}
              pageSize={PAGE_SIZE}
              onPageChange={handlePageChange}
            />
          </>
        )}

        {/* ── Course Bundle Plans ── */}
        {tabKey === 'bundle' && (
          <>
            <div className="flex items-start justify-between mb-4 gap-4">
              <div>
                <span className="text-sm font-semibold text-gray-900">Course Bundle Plans</span>
                <p className="text-xs text-gray-500 mt-0.5">Annual B2C plans containing curated course collections.</p>
              </div>
              <div className="flex items-center gap-2">
                <SearchInput
                  value={searchMap.bundle}
                  onChange={(v) => handleSearchChange('bundle', v)}
                  placeholder="Search bundles..."
                />
                <button
                  type="button"
                  onClick={handleToggleDeleted}
                  className="px-3 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 cursor-pointer"
                >
                  {showDeleted ? 'Hide deleted' : 'Show deleted'}
                </button>
                <CreateButton label={tabCreateLabel} route={tabRoute} navigate={navigate} activeTab={activeTab} />
              </div>
            </div>
            {loading
              ? <TableSkeletons />
              : (
                <PlanTable
                  plans={currentPlans}
                  columns={BUNDLE_COLUMNS}
                  onView={handleView}
                  onEdit={handleEdit}
                />
              )}
            <TablePagination
              total={currentTotal}
              page={currentPage}
              pageSize={PAGE_SIZE}
              onPageChange={handlePageChange}
            />
          </>
        )}

        {/* ── B2B Plans ── */}
        {tabKey === 'b2b' && (
          <>
            <div className="flex items-center justify-between mb-4">
              <B2BBanner
                createLabel={tabCreateLabel}
                onCreate={() => navigate(tabRoute)}
                showDeleted={showDeleted}
                onToggleDeleted={handleToggleDeleted}
              />
              <SearchInput
                value={searchMap.b2b}
                onChange={(v) => handleSearchChange('b2b', v)}
                placeholder="Search B2B plans..."
              />
            </div>
            {loading
              ? <CardSkeletons />
              : currentPlans.length > 0
                ? (
                  <PlansCardGrid
                    plans={currentPlans}
                    onView={handleView}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    onDeletePlan={handleDeletePlan}
                    onTogglePublish={handleTogglePublish}
                    isB2B
                  />
                )
                : <EmptyState label="B2B plans" />}
            <TablePagination
              total={currentTotal}
              page={currentPage}
              pageSize={PAGE_SIZE}
              onPageChange={handlePageChange}
            />
          </>
        )}

        {/* ── E-Books Plans ── */}
        {tabKey === 'ebooks' && (
          <>
            <div className="flex items-start justify-between mb-4 gap-4">
              <div>
                <span className="text-sm font-semibold text-gray-900">E-Books Plans</span>
                <p className="text-xs text-gray-500 mt-0.5">Annual B2C plans containing curated e-book collections.</p>
              </div>
              <div className="flex items-center gap-2">
                <SearchInput
                  value={searchMap.ebooks}
                  onChange={(v) => handleSearchChange('ebooks', v)}
                  placeholder="Search e-book plans..."
                />
                <button
                  type="button"
                  onClick={handleToggleDeleted}
                  className="px-3 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 cursor-pointer"
                >
                  {showDeleted ? 'Hide deleted' : 'Show deleted'}
                </button>
                <CreateButton label={tabCreateLabel} route={tabRoute} navigate={navigate} activeTab={activeTab} />
              </div>
            </div>
            {loading
              ? <TableSkeletons />
              : (
                <PlanTable
                  plans={currentPlans}
                  columns={EBOOKS_COLUMNS}
                  onView={handleView}
                  onEdit={handleEdit}
                />
              )}
            <TablePagination
              total={currentTotal}
              page={currentPage}
              pageSize={PAGE_SIZE}
              onPageChange={handlePageChange}
            />
          </>
        )}
      </div>

      <EditDrawer
        open={Boolean(editPlan)}
        plan={editPlan}
        planType={tabKey}
        onClose={() => setEditPlan(null)}
        onSave={handleSaveEdit}
      />

      <SnackBar
        open={snackbar.open}
        snackbarTitle={snackbar.title}
        close={() => setSnackbar({ open: false, title: '' })}
      />
    </Page>
  );
};

export default Subscriptions;